import { RolesPermissionState } from './roles-permissions.state';
import * as RolesPermissionsAction from './roles-permissions.actions';
import { Action, on, createReducer } from '@ngrx/store';

export const ROLES_PERMISSION_KEY = 'permissions';

export interface RolesPermissionPartialState {
    readonly [ROLES_PERMISSION_KEY]: RolesPermissionState;
}

export const initialState: RolesPermissionState = {
    loading: false,
    permissions: undefined,
    error: false
};

const reducer = createReducer(
    initialState,
    on(RolesPermissionsAction.loadingRolesPermissions, state => ({
        ...state,
        loading: true
    })),
    on(RolesPermissionsAction.permissionLoaded, (state, { permissions }) => ({
        ...state,
        loading: false,
        permissions
    })),
    on(RolesPermissionsAction.permissionLoadingError, state => ({
        ...state,
        loading: false,
        error: true
    })),
);

export function rolesPermissionReducer(state: RolesPermissionState | undefined, action: Action) {
    return reducer(state, action);
}
